import styled from 'styled-components'

export const ClientLogoHeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`
export const IntroductionHeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: center;
	text-align: center;
`
